import type { BlockAccordion } from 'types/block-accordion';
import React from 'react';
import {
  Collapsible,
  CollapsibleProps,
  RichText,
  Wrap,
} from '@leafwell/components';
import IntroSimple from './intro-simple';

const Accordion: React.FC<BlockAccordion> = ({
  title,
  description,
  icon,
  sectionId,
  items,
  variant = 'gradient',
}) => {
  const hasTitle = title?.length > 0;
  return (
    <Wrap id={sectionId} className="!gap-y-4">
      {(title || description || icon) && (
        <IntroSimple title={title} description={description} icon={icon} />
      )}
      {items.map(({ title, description }) => (
        <Collapsible
          key={title}
          title={title}
          variant={variant as CollapsibleProps['variant']}
          className="text-gray-600"
          titleLarge={variant === 'minimal' ? true : false}
          titleTagName={hasTitle ? 'h3' : 'h2'}
        >
          <RichText content={description} className="font-small" />
        </Collapsible>
      ))}
    </Wrap>
  );
};

export default Accordion;
